import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
    getPropertyTypeBreakdownSuccess,
    getPropertyTypeBreakdownFailure,
    getSecuritiesStatusBreakdownSuccess,
    getSecuritiesStatusBreakdownFailure,
    getLoanStatusBreakdownSuccess,
    getLoanStatusBreakdownFailure,
    getClosingDateBreakdownSuccess,
    getClosingDateBreakdownFailure,
    getLoansSummarySuccess,
    getLoansSummaryFailure,
    getCashflowPerMonthBreakdownSuccess,
    getCashflowPerMonthBreakdownFailure,
    getDashboardSummaryTotalsSuccess,
    getDashboardSummaryTotalsFailure,
} from './actions';
import {
    GET_PROPERTY_TYPE_BREAKDOWN,
    GET_SECURITIES_STATUS_BREAKDOWN,
    GET_LOAN_STATUS_BREAKDOWN,
    GET_CLOSING_DATE_BREAKDOWN,
    GET_LOANS_SUMMARY,
    GET_CASHFLOW_PER_MONTH_BREAKDOWN,
    GET_DASHBOARD_SUMMARY_TOTALS,
} from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

// Get Property Type Breakdown
function* getPropertyTypeBreakdownSaga({ }) {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetPropertyTypeBreakdown`, options);
        const responseData = Object.keys(response)
            .filter(key => key !== 'status')
            .map(key => response[key]);
        yield put(getPropertyTypeBreakdownSuccess(responseData.length ? responseData : []));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = (error.description || 'An unknown error occurred');
        }
        yield put(getPropertyTypeBreakdownFailure(message));
    }
};

// Get Securities Status Breakdown
function* getSecuritiesStatusBreakdownSaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetSecuritiesStatusBreakdown`, options);
        const responseData = Object.keys(response)
            .filter(key => key !== 'status')
            .map(key => response[key]);
        yield put(getSecuritiesStatusBreakdownSuccess(responseData.length ? responseData : []));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = (error.description || 'An unknown error occurred');
        }
        yield put(getSecuritiesStatusBreakdownFailure(message));
    }
}

// Get Loan Status Breakdown
function* getLoanStatusBreakdownSaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetLoanStatusBreakdown`, options);
        const responseData = Object.keys(response)
            .filter(key => key !== 'status')
            .map(key => response[key]);
        yield put(getLoanStatusBreakdownSuccess(responseData.length ? responseData : []));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = (error.description || 'An unknown error occurred');
        }
        yield put(getLoanStatusBreakdownFailure(message));
    }
}

// Get Closing Date Breakdown
function* getClosingDateBreakdownSaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetClosingDateBreakdown`, options);
        const responseData = Object.keys(response)
            .filter(key => key !== 'status')
            .map(key => response[key]);
        yield put(getClosingDateBreakdownSuccess(responseData.length ? responseData : []));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = (error.description || 'An unknown error occurred');
        }
        yield put(getClosingDateBreakdownFailure(message));
    }
}

// Get Loans Summary
function* getLoansSummarySaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetStatusSummary`, options);
        const responseData = Object.keys(response)
            .filter(key => key !== 'status')
            .map(key => response[key]);
        yield put(getLoansSummarySuccess(responseData.length ? responseData : []));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = (error.description || 'An unknown error occurred');
        }
        yield put(getLoansSummaryFailure(message));
    }
}

// GET Cashflow per Month
function* getCashflowPerMonthBreakdownSaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetCashFlowBarChart`, options);
        const responseData = Object.keys(response)
                    .filter(key => key !== 'status')
                    .map(key => response[key]);
        yield put(getCashflowPerMonthBreakdownSuccess(responseData.length ? responseData : []));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = (error.description || 'An unknown error occurred');
        }
        yield put(getCashflowPerMonthBreakdownFailure(message));
    }
};

// GET Dashboard Summary Totals
function* getDashboardSummaryTotalsSaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetDashboardChart`, options);
        // Remove the 'status' key and keep the rest as an object
        const { status, ...data } = response;
        yield put(getDashboardSummaryTotalsSuccess(Object.keys(data).length ? data : {}));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = (error.description || 'An unknown error occurred');
        }
        yield put(getDashboardSummaryTotalsFailure(message));
    }
}

export function* watchGetPropertyTypeBreakdown() {
    yield takeEvery(GET_PROPERTY_TYPE_BREAKDOWN, getPropertyTypeBreakdownSaga);
}
export function* watchGetSecuritiesStatusBreakdown() {
    yield takeEvery(GET_SECURITIES_STATUS_BREAKDOWN, getSecuritiesStatusBreakdownSaga);
}
export function* watchGetLoanStatusBreakdown() {
    yield takeEvery(GET_LOAN_STATUS_BREAKDOWN, getLoanStatusBreakdownSaga);
}
export function* watchGetClosingDateBreakdown() {
    yield takeEvery(GET_CLOSING_DATE_BREAKDOWN, getClosingDateBreakdownSaga);
}
export function* watchGetLoansSummary() {
    yield takeEvery(GET_LOANS_SUMMARY, getLoansSummarySaga);
}
export function* watchGetCashflowPerMonthBreakdown() {
    yield takeEvery(GET_CASHFLOW_PER_MONTH_BREAKDOWN, getCashflowPerMonthBreakdownSaga);
}
export function* watchGetDashboardSummaryTotals() {
    yield takeEvery(GET_DASHBOARD_SUMMARY_TOTALS, getDashboardSummaryTotalsSaga);
}


function* ReportsSaga() {
    yield all([
        fork(watchGetPropertyTypeBreakdown),
        fork(watchGetSecuritiesStatusBreakdown),
        fork(watchGetLoanStatusBreakdown),
        fork(watchGetClosingDateBreakdown),
        fork(watchGetLoansSummary),
        fork(watchGetCashflowPerMonthBreakdown),
        fork(watchGetDashboardSummaryTotals),
    ]);
}

export default ReportsSaga;
